import { render, staticRenderFns } from "./following.vue?vue&type=template&id=3f5fd316&scoped=true&"
import script from "./following.vue?vue&type=script&lang=js&"
export * from "./following.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5fd316",
  null
  
)

export default component.exports